export default "__VITE_ASSET__B7xS$_Pe__"